import React, { useState } from "react";
import { SchemaWorkflow } from "../components/SchemaWorkflow";
import { ValidationScreen } from "../components/ValidationScreen";
import { ConfirmationScreen } from "../components/ConfirmationScreen";
import ComingSoon from "app/components/common/ComingSoon";

const schema = {
  id: "custom",
  name: "Custom Fields",
  description: "Update school-specific custom field values",
  columns: [
    { name: "Admission Number", type: "text", required: true },
    { name: "Session", type: "text", required: true },
    { name: "Custom Field 1", type: "text" },
    { name: "Custom Field 2", type: "text" },
    { name: "Custom Field 3", type: "text" },
  ],
};

export default function CustomFieldsInfo({ onBack }) {
  const IsComingSoon= true;
  const [currentStep, setCurrentStep] = useState("upload");
  const [uploadedData, setUploadedData] = useState([]);
  const [validationResults, setValidationResults] = useState(null);
  const [updateResults, setUpdateResults] = useState(null);
  

  const handleFileValidated = (data, results) => {
    setUploadedData(data);
    setValidationResults(results);
    setCurrentStep("validation");
  };

  const handleProceed = () => {
    const results = {
      total: validationResults.total,
      valid: validationResults.valid,
      invalid: validationResults.invalid,
    };
    setUpdateResults(results);
    setCurrentStep("confirmation");
  };

  const handleBackToUpload = () => {
    setCurrentStep("upload");
    setValidationResults(null);
  };

  const handleBackToDashboard = () => {
    onBack();
  };
  if (IsComingSoon) {
    return <ComingSoon />;
  }
  if (currentStep === "upload") {
    return (
      <SchemaWorkflow
        schema={schema}
        onBack={handleBackToDashboard}
        onFileValidated={handleFileValidated}
      />
    );
  }

  if (currentStep === "validation" && validationResults) {
    return (
      <ValidationScreen
        schema={schema}
        data={uploadedData}
        validationResults={validationResults}
        onReupload={handleBackToUpload}
        onProceed={handleProceed}
      />
    );
  }

  if (currentStep === "confirmation" && updateResults) {
    return (
      <ConfirmationScreen
        results={updateResults}
        onBackToDashboard={handleBackToDashboard}
      />
    );
  }

  return null;
}
